import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';
import { Modal } from 'bootstrap';
import { skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-development-budget-expenditurereport',
  templateUrl: './development-budget-expenditurereport.component.html',
  styleUrls: ['./development-budget-expenditurereport.component.scss']
})
export class DevelopmentBudgetExpenditurereportComponent implements OnInit {

  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  circlesList: any[] = [];
  expenditureData: any[] = [];
  UserDetails: any;
  currentMonth: any = {};
  showButton = false;
  isCurrentMonthSaved: boolean = false;

  constructor(private fb: FormBuilder, private reportService: ReportsService,private authService: AuthService,
    private toastService: ToastService, private router: Router, private ActivatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],
    });

    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;

    this.ActivatedRoute.queryParams.subscribe(params => {
      const financialYear = params['financialYear'];
      const blockId = Number(params['blockOffice']);
      // if(financialYear && blockId){
      //   this.targetForm.patchValue({
      //     financialYear: financialYear,
      //     blockOffice: blockId
      //   });


      if (financialYear) {
        this.targetForm.patchValue({ financialYear });
      }

      if (blockId) {
        this.targetForm.patchValue({ blockOffice: blockId });
      }

 if (this.UserDetails?.roleId == 11) {
      const userBlock = this.UserDetails?.iBlockId;

      this.targetForm.controls['blockOffice'].setValue(userBlock);
      this.targetForm.controls['blockOffice'].disable();


    }

      switch (this.UserDetails?.roleId) {
        case 13:

          break;
        case 1:
          this.targetForm.addControl('circleOffice', new FormControl({
            value: '',
            disabled: false
          }, Validators.required));
          this.getCircle();
          break;
        case 11:
          
          this.targetForm.controls['blockOffice'].disable();
          this.targetForm.get('blockOffice')?.valueChanges
            .pipe(skip(1))
            .subscribe((val: any) => {
              if (this.targetForm.valid) {
                this.getbudgetExpenditureData();
              }
            });

          break;
        default:
      }

    });

    if (this.targetForm.valid) {

      this.getbudgetExpenditureData();
    }
    this.GetBlock();
    this.getTargetCount();

    // const today = new Date();
    // const currentMonthYear = today.toISOString().slice(0, 7);
  }

  getMonthName(month: number) {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[month - 1];
  }

  // checkIfCurrentMonthSaved() {
  //   const currentMonth = new Date().getMonth() + 1; // 1–12

  //   // Suppose your API returns data with "dataMonth"
  //   if (this.expenditureData?.dataMonth === currentMonth) {
  //     this.isCurrentMonthSaved = true;
  //   }
  // }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {

        this.financialYears = res.data.financialYears
      }
    },
      (error: any) => {
      }
    );
  }

  getCircle() {
    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        this.circlesList = res.data.circles;
      }
    },
      (error: any) => {
      }
    );
  }


  GetBlock() {
    let obj = {
      "blockId": 0,
      "circleId": this.targetForm.value.circleOffice
    }

    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {
        this.blockList = res.data?.block;
        //this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }



  getbudgetExpenditureData() {

    let obj = {
      "blockId": this.targetForm.getRawValue().blockOffice,
      "financialYear": this.targetForm.value.financialYear,
    }

    this.reportService.getExpenditureDetail(obj).subscribe((res: any) => {
      if (res) {
        if (res && res?.data && res?.data.length > 0) {
          this.expenditureData = res?.data;
          const currentMonthExists = this.expenditureData.some(
            (x: any) => x.dataMonth == this.currentMonth.key
          );


          if (currentMonthExists) {
            this.showButton = true;
          } else {
            this.showButton = false;
          }


        } else {
          this.expenditureData = []
          this.showButton = true;
          this.currentMonth.key = '1';
          // this.toastService.showInfo('NO Data Found!')
        }
      }
    },
      (error: any) => {
      }
    );
  }



  goToTarget() {

    this.router.navigate(
      ['/reports/developmentBudgetExpenditure'],
      {
        queryParams: {
          financialYear: this.targetForm.value.financialYear,
          blockOffice: this.targetForm.getRawValue().blockOffice
        }
      }
    );
    // this.router.navigate(['/reports/developmentBudgetExpenditure', this.targetForm.value.financialYear,this.targetForm.value.blockOffice]);
  }

  cancelDelete() {
    this.deleteIndex = 0;

  }

  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }

  deleteAuditConducted(id: any) {
    this.reportService.deleteDevelopmentExpenditure(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.getbudgetExpenditureData();
        }
      }
    },
      (error: any) => {
      }
    );
  }

  deleteIndex: any = 0;
  verifyAuditConducted(id: any) {

    this.reportService.verifyaDevelopmentExpenditure(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.getbudgetExpenditureData();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  editRow(row: any) {

    this.router.navigate(
      ['/reports/developmentBudgetExpenditure'],
      { queryParams: { data: JSON.stringify(row) } } // ✅ passing the object here
    );
  }

  // viewReport(row: any) {

  //   this.router.navigate(
  //     ['/reports/developmentBudgetExpenditure'],
  //     { queryParams: { data: JSON.stringify(row) } } // ✅ passing the object here
  //   );

  // }

  viewReport(row: any) {

    this.router.navigate(
      ['/reports/developmentBudgetExpenditure'],
      {
        queryParams: {
          data: JSON.stringify(row),
          viewMode: true   // ✅ add this flag
        }
      }
    );
  }

}
